export enum TooltipTextAlignment {
  Center = 'center',
  Inherit = 'inherit',
}
